<template>
  <qx-card title="列表">
    <EditDialog ref="editDialog" @sub="getData" />
    <SettlementDialog ref="settlementDialog" @sub="getData" />
    <LogRightDialog ref="logRightDialog" busiCode="220000002" />
    <ImportBtn
      :title="uploadList[activeUploadIndex].title"
      :fileUrl="uploadList[activeUploadIndex].fileUrl"
      ref="importBtn"
      :noShow="true"
      :customPost="true"
      :isCustomDownload="true"
      @customDownload="customDownload"
      @sub="importPost"
    />
    <section slot="titleRight">
      <qx-permpisions permpisions="6001701">
        <el-button
          type="primary"
          plain
          @click="sendBill(tableData.selectResult)"
          >发送工资单</el-button
        >
      </qx-permpisions>
      <qx-permpisions permpisions v-show="checkPermpisions('6001703') || checkPermpisions('6001704') ||checkPermpisions('6001705')">
        <el-dropdown>
          <el-button type="primary" plain>
            <i class="iconfont">&#xe6ac;</i>批量
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <qx-permpisions v-for="(item, index) in uploadList" :key="index">
              <el-dropdown-item
                @click.native="showImport(index)"
                v-if="checkPermpisions(item.permpisions)"
              >
                {{ item.label }}
              </el-dropdown-item>
            </qx-permpisions>
          </el-dropdown-menu>
        </el-dropdown>
      </qx-permpisions>
      <qx-permpisions permpisions="6001706">
        <el-button type="primary" plain @click="workerUpdateTmpl"
          >更新工资模板</el-button
        >
      </qx-permpisions>
      <qx-permpisions permpisions>
        <el-button type="primary" plain @click.native="exportData"
          >员工工资数据导出</el-button
        >
      </qx-permpisions>
      <qx-permpisions permpisions="6001707">
        <el-button type="primary" plain @click="toSetBill"
          >自定义工资单</el-button
        >
      </qx-permpisions>
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <el-table-column type="selection" width="55" />
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section v-if="scope.column.property === 'userName'">
                  <span class="primary cur" @click="toUserDetail(scope.row)">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <section v-else>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            fixed="right"
            width="140"
          >
            <template slot-scope="scope">
              <section>
                <qx-permpisions permpisions="6001708">
                  <span class="primary cur" @click="showEditDialiog(scope.row)"
                    >修改</span
                  >
                </qx-permpisions>
                <qx-permpisions
                  permpisions="6001709"
                  v-if="scope.row.state === 3 || scope.row.state === 4"
                >
                  <span
                    class="primary cur"
                    @click="showSettlementDialog(scope.row)"
                    >结算</span
                  >
                </qx-permpisions>
                <qx-permpisions permpisions>
                  <span class="primary cur" @click="showLog(scope.row.staffId)"
                    >日志</span
                  >
                </qx-permpisions>
                <!-- 操作按钮 end -->
              </section>
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import { downloadBinaryFile } from 'api';
import {
  jsonParamsToUrlParams,
} from '@qx/utils';
import tableMixin from '@qx/mixin/table';
import EditDialog from './editDialog';
import SettlementDialog from './settlementDialog';
import LogRightDialog from 'components/logRightDialog';
import ImportBtn from 'components/importBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  workerSalaryList,
  workerSendBill,
  workerUpdateTmpl,
  importUpdate,
} from 'api/getPay';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    EditDialog,
    SettlementDialog,
    ImportBtn,
    TableSetting,
  },
  data () {
    return {
      activeUploadIndex: 0,
      exportStaffInfo: {
        url: '/cmStaffInfoNewBO.ajax?cmd=exportStaffInfo',
        urlWithParams: '',
      },
      uploadList: [
        {
          permpisions: '6001703',
          label: '修改',
          name: 'modify',
          title: '批量导入修改基本信息',
          fileUrl: '/file/修改工资单数据.xlsx',
          exportTemplateUrl: '/cmStaffInfoNewBO.ajax?cmd=exportForModify',
          batchImportUrl: '/cmStaffInfoNewBO.ajax?cmd=modifyStaffInfoByExcel',
        },
        {
          permpisions: '6001704',
          label: '发送工资单',
          name: 'sendPayroll',
          title: '批量发送工资单',
          fileUrl: '/file/确认（发送）工资单模板.xlsx',
          exportTemplateUrl: '/cmStaffInfoNewBO.ajax?cmd=exportTemplate',
          batchImportUrl: '/cmStaffInfoNewBO.ajax?cmd=opBillByExcel&operType=2',
        },
        {
          permpisions: '6001705',
          label: '结算',
          name: 'settlement',
          title: '批量导入工资结算',
          fileUrl: '/file/结算工资单模板.xlsx',
          exportTemplateUrl: '/cmStaffInfoNewBO.ajax?cmd=exportTemplate',
          batchImportUrl: '/cmStaffInfoNewBO.ajax?cmd=checkStaffInfoByExcel',
        },
      ],
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        selectTar: 'staffId',
        title: [ // 表头
          { prop: 'settleMonth', label: '结算月份', fixed: true },
          { prop: 'userName', label: '员工姓名' },
          { prop: 'userPhone', label: '员工手机号码' },
          { prop: 'attendanceDaysNumber', label: '应出勤天数' },
          { prop: 'actualAttendanceDays', label: '实际出勤天数' },
          { prop: 'basicSalaryFeeDouble', label: '基本工资' },
          { prop: 'meritPayDouble', label: '绩效工资' },
          { prop: 'subsidyFeeDouble', label: '加班补贴' },
          { prop: 'individualContributionDouble', label: '个人社保缴纳' },
          { prop: 'lastMonthDebtDouble', label: '上月欠款' },
          { prop: 'individualIncomeTaxDouble', label: '个税' },
          { prop: 'remark', label: '备注' },
          { prop: 'stateName', label: '状态' },
          { prop: 'realSalaryFeeDouble', label: '实发工资' },
          { prop: 'paidSalaryFeeDouble', label: '已结算工资' },
          { prop: 'checkDate', label: '结算时间' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: workerSalaryList,
    customDownload () {
      const currentTarget = this.uploadList[this.activeUploadIndex];
      downloadBinaryFile({
        url: currentTarget.exportTemplateUrlWithParams,
        fileName: currentTarget.fileUrl.replace(/\/file\//g, ''),
      });
    },
    setImportExportParams (data) {
      // 把查询参数添加到 url 上面
      for (let item of this.uploadList) {
        item.exportTemplateUrlWithParams = `${item.exportTemplateUrl}&${jsonParamsToUrlParams(data)}`;
        if (item.name === 'sendPayroll') {
          item.exportTemplateUrlWithParams += '&templateType=2';
        } else if (item.name === 'settlement') {
          item.exportTemplateUrlWithParams += '&templateType=4';
        }
      }
      this.exportStaffInfo.urlWithParams = `${this.exportStaffInfo.url}&${jsonParamsToUrlParams(data)}`;
    },
    // 导入修改
    showImport (activeUploadIndex) {
      this.activeUploadIndex = activeUploadIndex;
      this.$refs.importBtn.showImportDialog();
    },
    async importPost (data) {
      const res = await importUpdate(
        this.uploadList[this.activeUploadIndex].batchImportUrl,
        {
          myStaffFile: data.file,
        });
      if (!res.failed) {
        this.$message.success('保存成功');
        this.getData();
      } else {
        this.$confirm(res.message, '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          showCancelButton: false,
        });
      }
    },
    // 直接导出二进制文件
    async exportData () {
      const res = await downloadBinaryFile({
        url: this.exportStaffInfo.urlWithParams,
        fileName: '员工工资数据导出.xlsx',
      });
      if (!res.failed) {
        this.$message.success('操作成功');
      } else {
        this.$confirm(res.message, '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          showCancelButton: false,
        });
      }
    },
    toSetBill () { // 设置工资单
      this.jump({
        label: '自定义工资单',
        url: '/manage/getPay/writeOff/worker/setBill?id=1',
      });
    },
    async workerUpdateTmpl () { // 更新模板
      const res = await workerUpdateTmpl({
        settleMonth: this.searchBoxData.settleMonth,
      });
      if (!res.failed) {
        this.$message.success('更新成功');
      }
    },
    async sendBill (arr) { // 发送工资单
      if (arr.length === 0) {
        this.$message.warning('请先选择操作对象');
        return;
      }
      const salaryIds = arr.map((item) => item.staffId);
      const res = await workerSendBill({
        salaryIds: salaryIds.join(','),
      });
      if (!res.failed) {
        this.$message.success('发送成功');
        this.getData();
      }
    },
    showSettlementDialog (item) { // 结算
      this.$refs.settlementDialog.show(item);
    },
    showEditDialiog (item) { // 修改
      this.$refs.editDialog.show(item);
    },
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
    toUserDetail (item) {
      this.jump({
        label: '员工详情',
        url: `/manage/system/jurisdiction/worker/detail?id=${item.userId}`,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
